// extracted by mini-css-extract-plugin
export var active = "_93-7";
export var container = "_93-0";
export var evenWidth = "_93-4";
export var large = "_93-5";
export var outlet = "_93-8";
export var slide = "_93-2";
export var small = "_93-6";
export var tab = "_93-3";
export var tabs = "_93-1";